import { FC } from 'react';

import type { ProductNodeBuilderProps } from '../ProductNodeBuilder.model';

export const BlankField: FC<ProductNodeBuilderProps> = () => {
  return null;
};

BlankField.displayName = 'BlankField';
